import TreeCategoryList1 from "./TreeCategoryList1";


export const CategorySection1 = ({
  category_key,
  loading,
  title,
  data,
  hasClicked,
  onArticleClick,
    variant = "grid", 
}) => {
  const hasData = Array.isArray(data) && data.length > 0;



  return (
    <section className="mt-1 pt-2 border-t">
      {loading && (
        <p className="text-gray-500">Loading articles…</p>
      )}

      {!loading && !hasData && (
        <p className="text-gray-400 italic">
          No articles found in{" "}
          <span className="font-medium">{title}</span>
        </p>
      )}

      {hasData && (
        <>

          <TreeCategoryList1
            data={data}
            categoryName={title}
            category_key={category_key}
            onArticleClick={onArticleClick}
               variant={variant}  
          />
        </>
      )}
    </section>
  );
};

